export default __webpack_public_path__ + "static/media/Cubeb.90c69bd1.jpg";